import { jsx as o } from "react/jsx-runtime";
import { FoamLogo as t } from "../../../atoms/FoamLogo/FoamLogo.es.js";
import { chakra as m } from "@chakra-ui/react";
import { useFooterStyle as e } from "../Footer.context.es.js";
const f = () => {
  const r = e();
  return /* @__PURE__ */ o(m.div, { __css: r.logo, children: /* @__PURE__ */ o(t, {}) });
};
export {
  f as FooterLogo
};
//# sourceMappingURL=FooterLogo.es.js.map
